<!--
 * @Description: 奖池
 * @Author: yl
 * @Date: 2021-05-28 17:44:27
 * @LastEditTime: 2021-06-02 10:28:57
 * @LastEditors: yl
-->
<template>
    <van-grid-item>
        <div class="img-bg bg-100 bg bv">
            <div class="broadcast-area">
                <div class="broadcast">
                    <van-swipe ref='swipe' vertical :autoplay="isLottery ? 50 : 0" :duration='100' class="notice-swipe"
                        :show-indicators="false" :touchable="false">
                        <van-swipe-item v-if="!isLottery">
                            <van-image class="img" :src="resNum !== null ? nums[resNum] : prizeImg">
                                <template v-slot:loading>
                                    <van-loading type="spinner" size="20" />
                                </template>
                            </van-image>
                        </van-swipe-item>
                        <van-swipe-item v-else v-for="(item, i) in nums" :key="i">
                            <van-image class="img" :src="item">
                                <template v-slot:loading>
                                    <van-loading type="spinner" size="20" />
                                </template>
                            </van-image>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
        </div>
    </van-grid-item>
</template>

<script>
export default {
    components: {},
    name: "",
    props: {
        isLottery: null,
        resNum: null,
        isOver: null
    },
    watch: {
        isLottery: {
            handler(v) {
                if (!v) this.getRes();
            },
            immediate: false,
            deep: true
        }
    },
    data() {
        return {
            nums: [
                require("@/assets/imges/lottery/0.png"),
                require("@/assets/imges/lottery/1.png"),
                require("@/assets/imges/lottery/2.png"),
                require("@/assets/imges/lottery/3.png"),
                require("@/assets/imges/lottery/4.png"),
                require("@/assets/imges/lottery/5.png"),
                require("@/assets/imges/lottery/6.png"),
                require("@/assets/imges/lottery/7.png"),
                require("@/assets/imges/lottery/8.png"),
                require("@/assets/imges/lottery/9.png")
            ],
            prizeImg: require("@/assets/imges/lottery/prize.png")
        };
    },
    methods: {
        getRes() {
            this.$refs.swipe.swipeTo(this.resNum)
        }
    }
};
</script>

<style scoped lang="scss">
@include img-list("~@/assets/imges/lottery/", "bg");
.bg {
    width: 139px;
    height: 168px;
    display: flex;
    .broadcast-area {
        margin: 10px 0;
        height: 100%;
        overflow: hidden;
        // 轮播
        .broadcast {
            height: 100%;
            .notice-swipe {
                height: 100%;
            }
            .img {
                margin-top: -10px;
                padding: 45px 35px;
            }
        }
    }
}
</style>